import { useTranslation } from 'react-i18next';

import React from 'react';

import { Button } from '@thinkific/chalk/Button';
import { Text } from '@thinkific/chalk/Text';
import { Plus } from '@thinkific/chalk/react-icons';

import ConversationsList from 'components/new/chat/Conversations/ConversationsList';
import { useChatContext } from 'components/new/chat/providers/ChatProvider/ChatProvider';
import NavList from 'components/new/ui/MenuList/MenuList';

import BaseSidebar from './BaseSidebar';
import * as css from './DirectMessagingSidebar.css';

export const DirectMessagingSidebar = () => {
  const { t } = useTranslation();
  const { toggleNewConversationModal } = useChatContext();

  return (
    <BaseSidebar navItems={[]}>
      <section data-qa="messaging-menu-item">
        <NavList>
          <li className={css.menuItem} data-qa="members-menu-item">
            <Text variant="label.sm">{t('pages-direct_messages_new_message', 'New message')}</Text>
            <Button
              data-user-pilot-id="sidebar-conversation-plus-button"
              dataQa="create-conversation-plus-button"
              emphasis="low"
              icon={Plus}
              size="xs"
              hiddenLabel
              onClick={toggleNewConversationModal}
            >
              {t('sidebar-conversation-create', 'Create conversation')}
            </Button>
          </li>
          <ConversationsList captionLength={34} />
        </NavList>
      </section>
    </BaseSidebar>
  );
};
